/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MoveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconArrowBack from 'DesignSystem/Svgs/TysiaIconArrowBack/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MoveAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/Header/MoveAction"
  
}) {
let appointmentOverlayDockedToLeftValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'docked_to_left',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let appointmentOverlayDockedToLeftValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'docked_to_left',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 title={appointmentOverlayDockedToLeftValueData ? "Dock to the right" : "Dock to the left"}
 onClick={onClick}
 data="appointment_overlay.docked_to_left"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<div
  data-testid="MoveAction.Vertical"
  data-view-path={viewPath}
 style={{'--r-1-Z8vNVE': appointmentOverlayDockedToLeftValueData1 ? "180deg" : "0deg"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconArrowBack
  viewPath={`${viewPath}/TysiaIconArrowBack`}
 height={dtSpaceLs}
 width={dtSpaceLs}
/>
</div>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}